import { Component, OnInit, AfterContentChecked, OnDestroy, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Location, NgIf, NgFor, NgClass } from '@angular/common';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';



@Component({
  selector: 'app-top-categories',
  templateUrl: './top-categories.component.html',
  styleUrls: ['./top-categories.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    RouterLinkActive,
    RouterLink,
    NgClass,

  ],
})
export class TopCategoriesComponent
  implements OnInit {


  constructor( ) {}

  ngOnInit() {}


}
